import React, { useEffect } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
  FormControl, FormControlLabel, FormHelperText,
  IconButton, InputLabel, MenuItem, Select, Switch, TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik } from 'formik';
import { addUserSchema } from './userSchema';

const INITIAL = {
  name: '',
  companyEmail: '',
  password: '',
  role: 'user',
  is_active: true,
};

const AddUserDialog = ({ open, onClose, onSave, saving }) => {
  const formik = useFormik({
    initialValues: INITIAL,
    validationSchema: addUserSchema,
    onSubmit: (values) => onSave(values),
  });

  useEffect(() => {
    if (!open) formik.resetForm();
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 1 }}>
        Add New User
        <IconButton size="small" onClick={onClose} disabled={saving}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: '16px !important' }}>
        <TextField
          fullWidth
          label="Full Name"
          name="name"
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={formik.touched.name && formik.errors.name}
        />

        <TextField
          fullWidth
          label="Email"
          name="companyEmail"
          type="email"
          value={formik.values.companyEmail}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.companyEmail && Boolean(formik.errors.companyEmail)}
          helperText={formik.touched.companyEmail && formik.errors.companyEmail}
        />

        <TextField
          fullWidth
          label="Password"
          name="password"
          type="password"
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
        />

        <FormControl fullWidth error={formik.touched.role && Boolean(formik.errors.role)}>
          <InputLabel>Role</InputLabel>
          <Select
            name="role"
            value={formik.values.role}
            label="Role"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <MenuItem value="user">User</MenuItem>
            <MenuItem value="admin">Admin</MenuItem>
          </Select>
          {formik.touched.role && formik.errors.role && (
            <FormHelperText>{formik.errors.role}</FormHelperText>
          )}
        </FormControl>

        <FormControlLabel
          control={
            <Switch
              name="is_active"
              checked={formik.values.is_active}
              onChange={formik.handleChange}
            />
          }
          label={formik.values.is_active ? 'Active' : 'Inactive'}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!formik.isValid || saving}
          onClick={formik.submitForm}
        >
          {saving ? 'Creating...' : 'Create User'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddUserDialog;
